export const CardsPage = {
  en: {
    Cards: 'Cards',
    'No cards available': 'No cards available',
  },
  uk: {
    Cards: 'Картки',
    'No cards available': 'Картки відсутні',
  },
};

export const CardPage = {
  en: {
    Cost: 'Cost',
    Visits: 'Visits',
    Validity: 'Validity',
    Activation: 'Activation',
    Discount: 'Discount',
    'Unlimited visits': 'Unlimited visits',
    'Activation at purchase': 'At purchase',
    visits_one: '{{count}} visit',
    visits_other: '{{count}} visits',
    cardDays_one: '{{count}} day',
    cardDays_other: '{{count}} days',
    activationWithin_one: 'Within {{count}} day after purchase',
    activationWithin_other: 'Within {{count}} days after purchase',
    discountUses_one: 'up to {{count}} use',
    discountUses_other: 'up to {{count}} uses',
    'Card purchase failed': 'Could not start the purchase. Please try again.',
    'Card purchase unavailable':
      'Payment is temporarily unavailable. Please contact the administrator.',
  },
  uk: {
    Cost: 'Вартість',
    Visits: 'Відвідування',
    Validity: 'Термін дії',
    Activation: 'Активація',
    Discount: 'Знижка',
    'Unlimited visits': 'Без обмеження відвідувань',
    'Activation at purchase': 'При купівлі',
    visits_one: '{{count}} відвідування',
    visits_few: '{{count}} відвідування',
    visits_many: '{{count}} відвідувань',
    cardDays_one: '{{count}} день',
    cardDays_few: '{{count}} дні',
    cardDays_many: '{{count}} днів',
    activationWithin_one: 'Протягом {{count}} дня після купівлі',
    activationWithin_few: 'Протягом {{count}} днів після купівлі',
    activationWithin_many: 'Протягом {{count}} днів після купівлі',
    discountUses_one: 'до {{count}} використання',
    discountUses_few: 'до {{count}} використань',
    discountUses_many: 'до {{count}} використань',
    'Card purchase failed':
      'Не вдалося розпочати покупку. Спробуйте ще раз, будь ласка.',
    'Card purchase unavailable':
      'Оплата тимчасово недоступна. Зверніться, будь ласка, до адміністратора.',
  },
};
